


















































































































import PouchDB from "pouchdb";
import { genPostReq } from "@/services/checklist.service";
import ResultSlot from "@/components/inspections/ResultSlot.vue"
import ResultModal from "@/components/inspections/ResultModal.vue"


import { EventBus } from '@/event-bus.js';
import  { localPouchDb } from "@/inspect-db";



export default {
  data() {
    return {
      initLoaded: true,
      local_db: null, 
      search: null,
      activeTreeRow: {},
      the_task: null,
      tasks: [],
      open: [],
      lblTasks: "",
      loadingResult: false,
      //results: [],
      treeData: [],
      selectedResultEntry: {},
      showResultEdit: false,
      blubb: null,
      the_inspection: null, 
      selectedComponent: null,
    };
  },
  components: {
    ResultSlot,
    ResultModal
  },
  filters: {
    trim: function(string) {
      if (string) {
        return string.trim();
      }
    }
  },

  computed: {
    results() {
      return []
    },
    filter_tree() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
    inspections() {
      return this.$store.state.insp_inspections;
    },
    inspection() {
      if (this.$store.state.che_inspection) {
        return this.$store.state.che_inspection;
      }
      return {};
    },

    /*
    selectedComponent() {
      if (this.activeTreeRow.length > 0) {
        return this.activeTreeRow[0];
      }
      return null;
    },
    */
    sim_inspections() {
      let l = []
      if (this.$store.state.insp_inspections) {
        this.$store.state.insp_inspections.map((d) => {
          console.log(d)
          l.push({value: d.doc._id, text: d.doc.name.de})
        })
      }
      return l
    },
    tasks_list() {
      return this.tasks
    }
  },
  methods: {
    replicateComplete(data) {

      if (data.name == this.projectId) {
        console.log("alles super")
      }
    },


    getComponentEntry(id, children) {
     
    },
    onResultEdit(item) {

    },
    dialogResultEditClosed() {
      this.showResultEdit = false
    },
    loadResults(task_id) {
     
    },
    selTask() {
      this.selectedComponent.tasks.map( (d) => {
        if (this.the_task == d._id) {
          console.log("hallo", d)

          console.log(this.selectedComponent._id)

          return
        }
      })
      console.log(this.the_task)
    
    },
    inspectionToTree(tree_item, inspection, k) {     
      if (inspection.components && inspection.components.length > 0) {
        for (var i=0 ; i<inspection.components.length ; i++) {
          k++
          let item = { name: inspection.components[i].name.de, 
                       id: k+"_"+inspection.components[i]._id, 
                       children: [],
                       tasks: inspection.components[i].tasks }
          this.inspectionToTree(item.children, inspection.components[i], k)
          tree_item.push(item)
        }
      }
    },
    selInspection() {
      var k=0; 
      var ref = this
      this.treeData = []
        this.$store.state.insp_inspections.map((d) => {
          if (d.doc._id == this.the_inspection) {
            this.inspectionToTree(ref.treeData, d.doc, k)
            this.activeTreeRow = [ref.treeData[0]]
         
            return 
          }
        })
    },
    openTreeItem(item) {
      this.tasks = []
      var ref = this
      if (item && item[0]) {
        this.selectedComponent = item[0]
        if (item[0].tasks ) {
          item[0].tasks.map( (d) => {
            ref.tasks.push({text: d.name.de, value: d._id })
          })
        }
      }
    }
  },
  mounted() {
   
    this.projectId = 'project-19911331'

    this.local_db = localPouchDb(this.projectId)
   
    //EventBus.$on('replicate:complete', this.replicateComplete);

    this.$store.state.che_inspection = {};
    this.$store.state.cl_uid = this.$route.params.uid;
    this.$store.state.headerTitle = "Inspektionen";

    this.$store.state.initParams = {...this.$route.params}

    const ref = this

  },
  created() {},
  destroyed() {
    //EventBus.$off('replicate:complete', this.replicateComplete);
  }
};
